<template>
  <div class="custom-file">
    <input
      :id="`inputGroupFile_${name}`"
      :aria-describedby="`inputGroupFileAddon__${name}`"
      type="file"
      class="custom-file-input"
      lang="zh-TW"
      multiple
      @change="onChange"
    >
    <label
      :for="`inputGroupFile_${name}`"
      class="custom-file-label"
    >選擇檔案</label>
  </div>
</template>
<script>
import { isMimeTypeAvailable } from '~utils/file'
export default {
  name: 'InputFile',
  props: {
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    onChange (e) {
      const availableFiles = Array.from(e.target.files).map((file) => {
        if (isMimeTypeAvailable(file)) {
          return file
        }
      })
      this.$emit('change', availableFiles)
    }
  }
}
</script>
